// extracted by mini-css-extract-plugin
export var actionText = "_nj-4";
export var container = "_nj-0";
export var leftSection = "_nj-1";
export var rightSection = "_nj-2";
export var settingsButton = "_nj-6";
export var settingsIcon = "_nj-7";
export var shortcut = "_nj-5";
export var shortcutGroup = "_nj-3";